// ** Initial State
const initialState = {
  subTaskActionPerformed: 0,
};

const navbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SUB_TASK_ACTION_PERFORMED":
      return { ...state, subTaskActionPerformed: new Date().getTime() };
    default:
      return state;
  }
};

export default navbarReducer;
